import { decimalCalc } from "../../../../../../../server/lib/aggregate/common";

export const decimal = (num: number): number => {
	return num / 100;
};

export const calcDiffPercent = (initValue: number, targetValue: number): number => {
	return decimalCalc((targetValue / initValue) * 100 - 100, 10);
};
